import { get } from '../Services/http'
import { catchError } from './Error.action'

export const RESELLER_GOOGLE_MAP_LOAD = 'RESELLER_GOOGLE_MAP_LOAD'
export const RESELLER_GOOGLE_MAP_ERROR = 'RESELLER_GOOGLE_MAP_ERROR_ERROR'
export const RESELLER_GOOGLE_MAP_RECEIVE = 'RESELLER_GOOGLE_MAP_RECEIVE'
export const RESELLER_GOOGLE_MAP_SET_STATUS = 'RESELLER_GOOGLE_MAP_SET_STATUS'
export const RESELLER_GOOGLE_MAP_RECEIVE_FOR_PRODUCT = 'RESELLER_GOOGLE_MAP_RECEIVE_FOR_PRODUCT'

export const RESELLER_FETCH_STATUSES = {
    LOADING: 'loading',
    FULFILLED: 'fulfilled',
    ERROR: 'error,'
}

export const load = () => (dispatch, getState) => { 
    // return get('/api/resellers/reseller')
    //     .then(response => response.json())
    //     .then(data => dispatch(receive(data)))
    //     .catch(ex => dispatch(catchError(ex, error => loadError(error))))
}

export const loadForProduct = (variantId) => (dispatch, getState) => {
    return get(`/api/resellers/${variantId}`)
        .then(response => response.json())
        .then(data => dispatch(receiveForProduct(data)))
        .catch(ex => dispatch(catchError(ex, error => setStatus('error'))))
}

export const loadError = error => ({
    type: RESELLER_GOOGLE_MAP_ERROR,
    payload: {
        error,
    }
})

export const receive = data => {
    return ({
        type: RESELLER_GOOGLE_MAP_RECEIVE,
        payload: {
            reSellers: data,
        },
    });
}

export const setStatus = data => {
    return ({
        type: RESELLER_GOOGLE_MAP_SET_STATUS,
        payload: {
            status: data,
        },
    });
}

export const receiveForProduct = data => {
    // data.productOnlineResellers = [];

    return ({
        type: RESELLER_GOOGLE_MAP_RECEIVE_FOR_PRODUCT,
        payload: {
            status: 'fulfilled',
            ...data
        }
    });
}
